import { useState, useRef } from "react";

import "./ShowUIHelpers.scss";

export default function ShowUIHelpers() {
  const [isHidden, setIsHidden] = useState(true);

  const showHelperButtonEl = useRef(null);

  const toggleHidden = () => {
    const spacers = document.querySelectorAll(".spacer");
    const steps = document.querySelectorAll(".step");

    spacers.forEach((spacer) => {
      spacer.classList.toggle("show");
    });
    steps.forEach((step) => {
      step.classList.toggle("show");
    });
    setIsHidden((currentState) => {
      return !currentState;
    });
    showHelperButtonEl.current.classList.toggle("on");
  };

  return (
    <button
      className="show-helpers"
      onClick={toggleHidden}
      ref={showHelperButtonEl}
    >
      {isHidden ? (
        "Show Steps and Spacers"
      ) : (
        "Hide Steps and Spacers"
      )}
    </button>
  );
}
